/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_Group_ViewInputs */

const en_palette_group_view = /** @type {(inputs: Palette_Group_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

const de_palette_group_view = /** @type {(inputs: Palette_Group_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansicht`)
};

/**
* | output |
* | --- |
* | "View" |
*
* @param {Palette_Group_ViewInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const palette_group_view = /** @type {((inputs?: Palette_Group_ViewInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_Group_ViewInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_palette_group_view(inputs)
	return en_palette_group_view(inputs)
});